import React from 'react';
// tslint:disable-next-line: no-any
export const getInputValue = (value, defaultValue) => value || defaultValue || undefined;
export const renderInFragment = ({ key, node }) => (React.createElement(React.Fragment, { key: key }, node));
